exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".export {\n  color: #53a75c;\n  bottom: 0px;\n  position: absolute;\n  font-size: 20px;\n  -webkit-box-shadow: 1px 0px 1px 1px rgba(0, 0, 0, 0.04);\n          box-shadow: 1px 0px 1px 1px rgba(0, 0, 0, 0.04);\n  border-radius: 50px 50px; }\n\n.download {\n  color: rgba(0, 0, 0, 0.26);\n  text-decoration: none;\n  font-size: 10px; }\n\n.download:hover {\n  color: rgba(0, 0, 0, 0.26);\n  font-size: 11px;\n  text-decoration: underline;\n  -webkit-text-decoration-color: #673ab7;\n          text-decoration-color: #673ab7; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3336090493/src/src/app/common/dynamic-vendor-invoice-pie-chart/dynamic-vendor-invoice-pie-chart.component.scss
// module id = ../../../../../src/app/common/dynamic-vendor-invoice-pie-chart/dynamic-vendor-invoice-pie-chart.component.scss
// module chunks = main